import React from 'react';

export default function Facilities(props) {
  let facilities = props.facilities;
  let renderFacilities = facilities.map(function(facility_elem, index) {
    return <li key={index}>{facility_elem.name}</li>;
  });

  return (
    <div className="offer-facilities">
      <ul>{renderFacilities}</ul>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/facilities.jsx